import { Helmet } from 'react-helmet-async';
import { Link, Outlet } from 'react-router-dom';

import { Logo } from '@/components/ui/Logo';
import SkipLink from '@/components/layout/SkipLink';
import { useAccountTheme } from '@/components/layout/useAccountTheme';

import './accountLayout.css';

type FocusedLayoutProps = {
  chrome?: 'default' | 'bare';
};

const FocusedLayout = ({ chrome = 'default' }: FocusedLayoutProps) => {
  const isBare = chrome === 'bare';
  // Bare chrome is auth and client presentations, which keep the site theme.
  useAccountTheme(!isBare);

  return (
    <div className={isBare ? 'focused-shell min-h-screen bg-background' : 'focused-shell account-theme min-h-screen bg-background text-foreground'}>
      <SkipLink />
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      {!isBare && (
        <header className="focused-header account-header">
          <Link
            to="/"
            aria-label="Light Hunt home"
            className="account-header__brand"
          >
            <Logo />
          </Link>
          <Link
            to="/sequences"
            className="account-header__exit"
          >
            Exit to catalog
          </Link>
        </header>
      )}
      <main
        id="main-content"
        className={isBare
          ? 'focused-main focused-main--bare min-h-screen w-full max-w-none p-0'
          : 'focused-main container mx-auto px-4 py-8'}
        aria-label="Focused workspace"
        tabIndex={-1}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default FocusedLayout;
